<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
    </button>
</div>

  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link " aria-current="page" href="../menuReporte">Reportería</a>
    </li>

  </ul>

<html>
  <h1> Página principal para directores</h1>

  <!-- <button mat-button  (click)="redireccionar()">Crear encuestas</button> -->
<br>
<br>
 <!--<div  *ngFor="let encuesta  of listaencuesta let i = index" >
  <li>
    <a  aria-current="page" href="/encuestas/{{encuesta.encuesta_id}}" >{{encuesta.nombre}}</a>
  </li>
 </div> -->
</html>
